/*
 * SPDX-FileCopyrightText: 2023 SAP Spartacus team <spartacus-team@sap.com>
 *
 * SPDX-License-Identifier: Apache-2.0
 */

export * from './components/consent-form/consent-management-form.component';
export * from './components/consent-management.component';
export * from './consent-management.module';
